<template>
  <div>
    <section-title has-line title="Información de Enmienda" />
    <callout
      border-color="gray-2"
      class="mt-n2"
      class-main="bg-gray-9"
      has-gradient
      :has-toggle="false"
    >
      <div class="row my-2">
        <div class="d-flex flex-column col-md-3 col-sm-12">
          <span class="data-label mb-1">Número Enmienda:</span>
          <span class="color-black font-16 font-weight-bold">
            {{ value.contractNumberBase }}{{ value.contractNumberAdded }}
          </span>
        </div>
        <div class="col-md-9 col-sm-12 d-flex justify-content-end mt-3 mt-md-0">
          <div class="bg-white px-4 py-2">
            <span class="data-label">Enmendar:</span>
            <div class="row py-2">
              <div class="col">
                <check-box
                  v-model="value.amendmentTypeDateFlag"
                  :disabled="isReadOnly"
                  text="Vigencia"
                />
              </div>
              <div class="col">
                <check-box
                  v-model="value.amendmentTypeBalanceFlag"
                  :disabled="isReadOnly"
                  text="Monto"
                />
              </div>
              <div class="col">
                <check-box
                  v-model="value.amendmentTypeOtherFlag"
                  :disabled="isReadOnly"
                  text="Otro"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <error
                  v-if="showSelectionError"
                  message="Favor seleccionar vigencia, monto u otro a enmendar. "
                  variant="no-border"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </callout>
    <div v-if="showAmendmentReason">
      <section-title class="mt-3" has-line title="Razón de Enmienda" />
      <div class="row">
        <div class="col-12 pb-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="value.amendmentReason"
              custom-error-msg="Favor completar razón de enmienda."
              :disabled="isReadOnly"
              :error="errors[0]"
              :maxlength="3000"
              name="comment"
              :rows="1"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import SectionTitle from '@/components/common/page/SectionTitle';
import Error from '@/components/common/Error';
import Callout from 'custom-callout';

export default {
  name: 'AmendmentInformation',
  components: {
    SectionTitle,
    Error,
    Callout,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    isFormDirty: {
      type: Boolean,
      default: () => false,
    },
  },
  inject: ['injection'],
  computed: {
    showAmendmentReason() {
      return this.value.amendmentTypeOtherFlag == 1;
    },
    showSelectionError() {
      return (
        !this.value.amendmentTypeDateFlag &&
        !this.value.amendmentTypeBalanceFlag &&
        !this.value.amendmentTypeOtherFlag &&
        this.injection.isFormDirty
      );
    },
  },
};
</script>
